//Magic Numbers - I don't have a list of what they actually mean...
const getStatusValue = (status: number, progress = false) => {
    switch (status) {
        case 20:
        case 77:
            return progress ? 0 : "Request submitted";

        case 21:
        case 190:
        case 196:
            return progress ? 1 : "Job allocated";

        case 22:
            return progress ? 2 : "Job accepted";

        case 23:
            return progress ? 3 : "Enroute";

        case 32:
            return progress ? 4 : "On site";

        case 24:
            return progress ? 5 : "Installation in progress";

        default:
            return progress ? 6 : "";
    }
}

export const getStatusText = (status: number) => getStatusValue(status);

export const getProgress = (status: number) => getStatusValue(status, true) as number;

export default { getStatusText, getProgress };